const pageTitle = {
  'Page Title': 'Page Title',
};

export default pageTitle;
